<template lang="html">
  <v-container grid-list-md align-center>
    <ComponentEditProfile @getUsername="getUsername" />
  </v-container>
</template>

<script>
import ComponentEditProfile from "@/components/ComponentEditProfile";
export default {
  components: {
    ComponentEditProfile
  },
  data() {
    return {};
  },
  methods: {
    getUsername(name_emit) {
      this.$emit("getUsername", name_emit);
    }
  }
};
</script>

<style scoped></style>
